import { motion } from 'framer-motion';
import Aos from 'aos';
import 'aos/dist/aos.css';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
// import VideoData from '../../data/VIDEO_DATA.json';
import { useState } from 'react';
import { createStyles, Button, Center } from '@mantine/core';
import VideoCompo from '../components/content/video-component';
import { useEffect } from 'react';
import Breadcrumbs2Component from '../components/breadcrumbs/breadcrumbs2-component';
import { FooterCompo } from '../components';

import { useDispatch, useSelector } from 'react-redux';
import {
  fetchVideos,
  videoPush,
  videosIsEmpty,
  videosStore,
} from '../store/reducers/videoSlice';
const useStyle = createStyles((theme) => ({
  root: {
    overflow: 'hidden',
  },
  judul: {
    fontSize: 30,
    fontWeight: 700,
    color: '#4d4d4d',
    marginTop: 20,
    marginBottom: 40,
  },
  containerVideo: {
    overflow: 'hidden',
  },
  rowVideo: {
    gap: '4rem',
  },
  button: {
    marginTop: 20,
    marginBottom: 20,
    padding: '20px 30px',
    fontSize: 16,
    fontWeight: 700,
    height: 'auto',
  },
}));
const VideoContentPage = () => {
  const { classes } = useStyle();

  const videos = useSelector(videosStore);
  const empty = useSelector(videosIsEmpty);
  const dispatch = useDispatch();

  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });

    if (empty) {
      (async function fetch() {
        dispatch(await fetchVideos());
      })();
    }
  }, [empty, dispatch]);
  return (
    <motion.div
      className={classes.root}
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 0.3 } }}
    >
      <div className="container">
        <h1 className={classes.judul}>Video</h1>
      </div>
      <div className={`container mb-5  ${classes.containerVideo}`}>
        <div className="row">
          <div className="col col-lg-12">
            <div
              data-aos="fade-right"
              className={`row justify-content-center ${classes.rowVideo}`}
            >
              {videos?.map((item, key) => {
                return (
                  <VideoCompo
                    key={key}
                    myId={item.id}
                    video={item.cover_url}
                    title={item.title}
                    desc={item.caption}
                    likes={item.likes}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <Center>
          <Button
            color="teal.9"
            radius="xl"
            className={classes.button}
            onClick={async () =>
              dispatch(
                await fetchVideos(
                  videos[videos.length - 1].thumbnail_name,
                  videos[videos.length - 1].created_at.seconds,
                  videos[videos.length - 1].id
                )
              )
            }
          >
            Lainnya
          </Button>
        </Center>
      </div>
      <JumboTron2 />
      <FooterCompo />
    </motion.div>
  );
};
export default VideoContentPage;
